import { FacebookPageInfluencers, FacebookPageInfluencerProfile } from '@anytag/shared-organisms';
import { InfluencersTabType } from '@anytag/shared-types';
import { useSocialAccountSelectButtonProps } from './hooks';

export const FacebookPageInfluencersSearch = () => {
  const { getSortSelectButtonProps, getListSelectButtonProps } =
    useSocialAccountSelectButtonProps<FacebookPageInfluencerProfile>({
      socialMedia: InfluencersTabType.FACEBOOK_PAGE
    });

  return (
    <FacebookPageInfluencers
      getSortSelectButtonProps={getSortSelectButtonProps}
      getListSelectButtonProps={getListSelectButtonProps}
    />
  );
};
